module.exports = __webpack_public_path__ + "img/payroll05.6b08fa0d.jpeg";